import { IsArray, IsNotEmpty, IsString } from 'class-validator';

export class UnsafeCreateEntitiesDto {
	@IsString()
	@IsNotEmpty()
	public entityName: string;

	@IsArray()
	@IsNotEmpty()
	public entitiesToCreate: Record<string, any>[];
}
